module.exports = __webpack_public_path__ + "img/embaixador.d0f423ec.png";